export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10111.1ef94763.jpg";